/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
import React, { useState, useEffect } from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

import { useUser } from "~/Context/userContext";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import axios from "react-axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { postMessageBoardReply, postMessageBoardTopicClearTracker } from "~/api/getMessageBoard";
import { validateNonAuth, validateAuth } from "./TrackCommentValidationRules";
import useTrackCommentForm from "./useTrackCommentForm";
import { openFileUploader } from "~/Components/Elements/Global/FileUploader";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

import styled from "styled-components";

import "~/css/forms.less";

const closedComments = ["29376"];
const closedTopics = ["15110"];

export const Wrapper = styled.section`
  margin: 6px 0 6px 0;
`;
export const TipsWrapper = styled.section`
  display: inline;
  float: right;
`;
export const SignInLinkWrapper = styled.section`
  text-decoration: underline;
  display: inline-block;
  margin-left: 7px;
  &:hover {
    cursor: pointer;
    text-decoration: none;
  }
`;

const TrackCommentsForm = ({ track, topic, onReply, layoutCols = false }) => {
  const { state: userState, dispatch } = useUser();
  const [loading, setLoading] = useState(true);
  const [isLayoutCols, setIsLayoutCols] = useState(layoutCols);

  const [showMessage, setShowMessage] = useState(false);

  const messageDisplayTime = 5000;
  const initialFormValues = { trackComment: "" };

  useEffect(() => {
    setLoading(!userState.loaded);
    setIsLayoutCols(layoutCols);
  }, [userState.loaded, layoutCols]);

  useEffect(() => {
    if (showMessage) {
      const timer = setTimeout(() => {
        setShowMessage(false);
      }, messageDisplayTime);
      return () => clearTimeout(timer);
    }
  }, [showMessage]);

  const validate = !loading && userState.loggedin ? validateAuth : validateNonAuth;

  const postComment = async () => {
    setLoading(true);

    const authorName = (inputs.author && inputs.author.trim()) || "";
    const author = userState.loggedin ? `${userState.user.dir}loggedin` : authorName;
    const trackId = (track && track.id) || undefined;
    const topicId = (topic && parseInt(topic.id, 10)) || undefined;

    const payload = {
      trackId,
      threadId: topicId,
      comment: inputs.trackComment.trim(),
      author,
    };
    const response = await postMessageBoardReply(axios, payload);
    const threadId = (response && response.data && response.data.thread_id) || undefined;

    // track the topic, you must be logged in and topic exists (might not if its the first reply)
    // only chimney will have this feature now
    if (userState.loggedin && userState.user && userState.isChim && threadId) {
      await postMessageBoardTopicClearTracker(axios, {
        threadId: threadId,
        chimDir: userState.user.dir,
      });
    }
    setLoading(false);

    if (response.status === 200) {
      setShowMessage(true);
      clearForm();
      onReply(response.data.replies);
    }

    /*  
    http://www.dreamchimney.com/api/tracks/message-board/topic/21977/clear/tracker/ryan
    POST
    {threadId: "20980", chimdir: "ryan"}
      @TODO add icons under it

    */
  };

  const { inputs, handleInputChange, handleSubmit, insertLinkTag, insertImageTag, clearForm, errors } = useTrackCommentForm(
    initialFormValues,
    postComment,
    validate
  );

  const openSignin = () => {
    if (!userState.loggedin) {
      dispatch({ type: "signin_open" });
      return;
    }
  };

  const isTrackClosed = track && closedComments.includes(track.id);
  const isTopicClosed = topic && closedTopics.includes(topic.id);

  if (isTrackClosed || isTopicClosed) {
    return (
      <div>
        <FontAwesomeIcon icon={faTimes} style={{ marginRight: 10, fontSize: 30 }} />
        Comments for this track are closed. <FontAwesomeIcon icon={faTimes} style={{ marginLeft: 10, fontSize: 30 }} />
      </div>
    );
  }
  return (
    <Wrapper>
      {loading && (
        <SkeletonTheme color="#fff" highlightColor="#f3f3f3">
          <Skeleton count={1} />
        </SkeletonTheme>
      )}

      {showMessage && <Alert variant="success">Thanks. Your comment was added below.</Alert>}

      {
        <Form
          className="totd-form search-form"
          style={isLayoutCols ? { marginTop: "16px" } : {}}
          noValidate
          onSubmit={(e) => handleSubmit(e)}
        >
          {!loading && !userState.loggedin && (
            <Form.Group as={Row} className={errors.author ? "error" : ""}>
              <Col md={isLayoutCols ? 12 : 6}>
                <div style={{ display: "flex" }}>
                  <Form.Control
                    disabled={loading}
                    name="author"
                    onChange={handleInputChange}
                    value={inputs.author || ""}
                    type="text"
                    autoComplete="off"
                    placeholder="Your Name"
                    style={{ width: "50%" }}
                  />
                  <span style={{ marginLeft: "16px", marginTop: "10px", fontSize: "12px" }}>
                    or <SignInLinkWrapper onClick={openSignin}>Login / Register</SignInLinkWrapper>
                  </span>
                </div>
                {errors.author && <span className="help error">{errors.author}</span>}
              </Col>
            </Form.Group>
          )}
          <Form.Group controlId="trackComment" className={errors.trackComment ? "error" : ""}>
            <Form.Control
              disabled={loading}
              id="trackComment"
              name="trackComment"
              onChange={handleInputChange}
              value={inputs.trackComment || ""}
              as="textarea"
              rows="2"
              placeholder="Add a comment..."
            />
          </Form.Group>

          <Button disabled={loading} variant="success" type="submit">
            Reply
          </Button>
          {userState.loggedin && !layoutCols && (
            <TipsWrapper className="tips">
              HTML Help:&nbsp;
              <a href="javascript:;" onClick={() => insertLinkTag()}>
                Add link
              </a>
              &nbsp;&nbsp;&nbsp;
              <a href="javascript:;" onClick={() => insertImageTag()}>
                Add Image Tag
              </a>
              &nbsp;&nbsp;&nbsp;
              {userState.isChim && (
                <a href="javascript:;" className="imageUploadButton" onClick={() => openFileUploader("trackComment")}>
                  Add / Upload an image
                </a>
              )}
            </TipsWrapper>
          )}
        </Form>
      }
    </Wrapper>
  );
};

export default TrackCommentsForm;
